// extracted by mini-css-extract-plugin
export var root = "_49lE";
export var rootList = "_4nvF";
export var rootListItem = "vlk5";
export var rootListItemHiddenDesktop = "i59e";
export var rootListItemHiddenMobile = "kClI";
export var rootListItemLabel = "i2O6";
export var rootListItemLabelBadge = "inMW";
export var rootListItemLabelIcon = "yH-d";
export var rootListItemMegaMenu = "_8vpJ";
export var rootListItemOrange = "Bjk4";
export var rootListItemRed = "ZN+M";
export var rootMobileOpened = "e7ek";
export var rootOverflowHidden = "qpWk";
export var rootSearching = "fIxm";